// components/AvatarCircle.jsx: M3-9 reusable avatar.
//
// Colored circle with a single uppercase letter (first char of display
// name). Used by the identity panel preview, the lobby occupant list
// (M3-10), and the M4 scoreboard. Pure presentational, props in, JSX
// out, no state, no localStorage.

import { AVATAR_COLORS } from '../identity/avatar-colors.js';
import { pickColorKey, pickAvatarLetter, composeAvatarLabel, avatarFontSize } from './avatar-helpers.js';

/**
 * @param {{
 *   color?: import('../identity/avatar-colors.js').AvatarColorKey,
 *   name?:  string,
 *   size?:  number,
 *   ariaLabel?: string,
 * }} props
 */
export function AvatarCircle({ color, name, size = 44, ariaLabel }) {
  const colorKey = pickColorKey(color);
  const hex = AVATAR_COLORS[colorKey].hex;
  const letter = pickAvatarLetter(name);
  const label = composeAvatarLabel(name, colorKey, ariaLabel);
  return (
    <span
      class="avatar-circle"
      role="img"
      aria-label={label}
      data-testid="avatar-circle"
      data-avatar-color={colorKey}
      data-avatar-letter={letter}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: size,
        height: size,
        borderRadius: '50%',
        background: hex,
        color: '#1A1422',
        fontWeight: 700,
        // Restyle 3A: a screen may set --avatar-letter-size to put the
        // letter on its type grid; elsewhere the old size stays.
        fontSize: `var(--avatar-letter-size, ${avatarFontSize(size)}px)`,
        lineHeight: 1,
        letterSpacing: 0,
        userSelect: 'none',
        flexShrink: 0,
      }}
    >
      {letter}
    </span>
  );
}
